module.exports = "/_next/static/images/ny-2-d5f4b806ddc94d85f876e71882283b29.jpg";